// @flow
import React, { Component } from 'react';
import Typography from 'material-ui/Typography';

import Console from '../../lib/debug';
import DateSelection from './DateSelection';
import DateRangeSelection from './DateRangeSelection';
import TeamSelection from '../common/TeamSelection';
import AthleteSelection from '../common/AthleteSelection';
import ExerciseSelection from '../common/ExerciseSelection';
import UseMetricSelector from '../common/UseMetricSelector';
import MarketplaceProductSelection from '../common/MarketplaceProductSelection';

import type { DateSelectionProps } from './DateSelection';
import type { DateRangeSelectionProps } from './DateRangeSelection';
import type { TeamSelectionProps } from '../common/TeamSelection';
import type { AthleteSelectionProps } from '../common/AthleteSelection';
import type { ExerciseSelectionProps } from '../common/ExerciseSelection';
import MonthSelection from './MonthSelection';

type Props = {
    datePicker?: DateSelectionProps,
    dateRangePicker?: DateRangeSelectionProps,
    teamSelector?: TeamSelectionProps,
    athleteSelector?: AthleteSelectionProps,
    exerciseSelector?: ExerciseSelectionProps
};

export default class AnalyticsFilterBar extends Component<Props> {
    static defaultProps = {
        datePicker: null,
        dateRangePicker: null,
        teamSelector: null,
        athleteSelector: null,
        exerciseSelector: null
    };

    getDatePicker = () => {
        if (!this.props.datePicker) {
            return null;
        }

        const { date, onChange } = this.props.datePicker;

        return <DateSelection date={date} onChange={onChange} />;
    };

    getDateRangePicker = () => {
        if (!this.props.dateRangePicker) {
            return null;
        }

        const { startDate, endDate, onChange } = this.props.dateRangePicker;

        return (
            <DateRangeSelection
                startDate={startDate}
                endDate={endDate}
                onChange={onChange}
            />
        );
    };

    getMonthSelection = () => {
        if (!this.props.monthSelection) {
            return null;
        }

        const {
            startDate,
            endDate,
            onChange,
            minDate
        } = this.props.monthSelection;

        return (
            <MonthSelection
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                onChange={onChange}
            />
        );
    };

    getTeamSelector = () => {
        if (!this.props.teamSelector) {
            return null;
        }

        return <TeamSelection {...this.props.teamSelector} />;
    };

    getMarketplaceProductSelector = () => {
        if (!this.props.marketplaceProductSelector) {
            return null;
        }

        return (
            <MarketplaceProductSelection
                {...this.props.marketplaceProductSelector}
            />
        );
    };

    getAthleteSelector = () => {
        if (!this.props.athleteSelector) {
            return null;
        }

        return <AthleteSelection {...this.props.athleteSelector} />;
    };

    getExerciseSelector = () => {
        if (!this.props.exerciseSelector) {
            return null;
        }

        return <ExerciseSelection {...this.props.exerciseSelector} />;
    };

    getUseMetricSelector = () => {
        if (!this.props.useMetricSelector) {
            return null;
        }

        return <UseMetricSelector {...this.props.useMetricSelector} />;
    };

    render() {
        Console.render('AnalyticsFilterBar');
        const datePicker = this.getDatePicker();
        const dateRangePicker = this.getDateRangePicker();
        const teamSelector = this.getTeamSelector();
        const marketplaceProductSelector = this.getMarketplaceProductSelector();
        const athleteSelector = this.getAthleteSelector();
        const exerciseSelector = this.getExerciseSelector();
        const useMetricSelector = this.getUseMetricSelector();
        const monthSelection = this.getMonthSelection();
        return (
            <div className="table-filter overall-container">
                {marketplaceProductSelector}
                {athleteSelector}
                {teamSelector}
                {exerciseSelector}
                {datePicker}
                {dateRangePicker}
                {monthSelection}
                <Typography className="flex" />
                {useMetricSelector}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/analytics/AnalyticsFilterBar.jsx